export const constants = {
    storageKey: 'sessionData',
    debounceTime: '600ms',
    filterDebounceTime: '75ms',
    pageSize: 50
};